import { render, staticRenderFns } from "./ListeningPhonicsForm.vue?vue&type=template&id=d4712872&"
import script from "./ListeningPhonicsForm.vue?vue&type=script&lang=js&"
export * from "./ListeningPhonicsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports